<template class="currency-kind-page">
  <v-card>
    <ac-data-table
      ref="table"
      :headers="headers"
      :items="items"
      :item-class="classObj"
      item-key="uid"
      fixed-header
      :footer-props="footer"
      :items-per-page="50"
      :height="winsize.height - 145 - 48"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Currency Kind"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Currency Kind
        </v-btn>
        <v-btn @click="exportData" class="ma-2" color="accent">
          EXPORT TO JSON
        </v-btn>
      </template>

      <template v-slot:item.item="{ item }">
        {{ item.item?.key || '' }}
      </template>

      <template v-slot:item.group="{ item }">
        {{ item.group?.key || '' }}
      </template>

      <template v-slot:item.modifier="{ item }">
        {{ item.modifier || '' }}
      </template>

      <template v-slot:item.shared="{ item }">
        {{ item.shared === true || item.shared === 1 ? 'true' : 'false' }}
      </template>

      <template v-slot:item.collectEffect="{ item }">
        {{ item.collectEffect === true || item.collectEffect === 1 ? 'true' : 'false' }}
      </template>

      <template v-slot:item.maps="{ item }">
        <div>
          <v-tooltip
            v-if="item.maps?.length > 3"
            bottom
            content-class="currency-kind-page__ttip"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                class="currency-kind-page__item-maps-coll"
                @click="copyMaps(item.maps)"
              >
                [Map Collection]
              </span>
            </template>
            <span>{{ item.maps.join(', ') }}</span>
          </v-tooltip>

          <span
            v-else
            class="currency-kind-page__item-maps"
          >
            {{ item.maps?.join(', ') || '-' }}
          </span>
        </div>
      </template>

      <template v-slot:item.actions="{item}">
        <div style="white-space: nowrap">
          <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
            mdi-eye
          </v-icon>
          <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
            mdi-pencil
          </v-icon>
          <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
            mdi-pencil
          </v-icon>
          <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
            mdi-content-copy
          </v-icon>
          <v-icon :disabled="item.global || item.sharedScope" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
          <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
            mdi-delete
          </v-icon>
        </div>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-currency-kind-dialog ref="dialog"/>
  </v-card>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {saveAs} from "file-saver";
import clsx from 'clsx';

import RCurrencyKindDialog from "@/modules/redactor/views/currency-kind/r-currency-kind-dialog.vue";
import VueTypes from "vue-types";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import AcDataTable from "@/components/Table/ac-data-table.vue";


export default {
  name: "r-currency-kind-page",
  components: {AcDataTable, RCurrencyKindDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Key", value: "key"},
      {text: "Code", value: "code"},
      {text: "Item", value: "item"},
      {text: "Group", value: "group"},
      {text: "Amount", value: "amount"},
      {text: "Capacity", value: "capacity"},
      {text: "Recovery Capacity", value: "recoveryCapacity"},
      {text: "Recovery Duration", value: "recoveryDuration"},
      {text: "Modifier", value: "modifier"},
      {text: "Weight", value: "weight"},
      {text: "Shared", value: "shared"},
      {text: "Collect Effect", value: "collectEffect"},
      {text: "Owners", value: "owners"},
      {text: "Maps", value: "maps"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(CurrencyKindModel)
    },
    footer: {
      "items-per-page-options": [10, 50, 100, -1]
    },
    selected: [],
    bulkMode: false,
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    classObj(item) {
      const highlightClass =
        item.global ? "cyan lighten-4" :
        item.export ? "green lighten-3" :
        item.changed ? "blue lighten-3" :
        !item.enabled ? "blue-grey lighten-3" :
        "";

      return clsx("currency-kind-page__item", highlightClass);
    },

    copyMaps(maps) {
      if (!maps || maps.length <= 3) return;

      const text = maps.join(', ');

      navigator.clipboard.writeText(text)
        .then(() => {
          this.$alert?.("Copied to clipboard!") || console.log("Copied:", text);
        })
        .catch(err => {
          console.error("Clipboard copy failed:", err);
        });
    },

    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {
      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {
            RedactorUtils.pushCurrencyKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushCurrencyKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushCurrencyKind(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeCurrencyKind(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkCurrencyKinds(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushCurrencyKind(result);
    },

    exportData() {
      RedactorUtils.exportCurrencyKinds()
        .then(data => {
          try {
            const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
            const formattedData = Object.entries(parsedData).map(([key, value]) => ({
              key: value.key || key,
              maps: value.maps || [],
            }));

            const blob = new Blob([JSON.stringify(formattedData, null, 2)], {
              type: "application/json"
            });

            saveAs(blob, "exported_currency-kinds.json");
          } catch (error) {
            console.error("Error while processing JSON: ", error);
          }
        })
        .catch(error => console.error("Export error: ", error));
    },

    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.sharedScope;
    },
  },
  created() {
    this.items = RedactorUtils.getCurrencyKinds();
  }
}
</script>

<style scoped lang="scss">
.currency-kind-page {
  &__item {
    white-space: nowrap;

    &-maps {
      color: #424242;

      &-coll {
        color: #1976d2;
        text-decoration: underline dotted;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }

  &__ttip {
    background-color: #000;
    color: #fff;
  }
}

::v-deep .v-data-table thead th {
  white-space: nowrap;
}
</style>
